<footer class="sidebar-copyright">
  Copyright &copy; 2022–2026 Crypto Explorer™. All rights reserved
</footer>
